__turbopack_context__.v({
  "discountedPrice": "TripLoyaltyPriceRow-module__qIbizq__discountedPrice",
  "originalPrice": "TripLoyaltyPriceRow-module__qIbizq__originalPrice",
  "originalTotal": "TripLoyaltyPriceRow-module__qIbizq__originalTotal",
  "priceRow": "TripLoyaltyPriceRow-module__qIbizq__priceRow",
});
